module.exports = __webpack_public_path__ + "img/Spanish.eb6ea10e.svg";